import { Outlet } from "react-router";
import { ScrollArea } from "@/components/ui/scroll-area";

export default function StaffLayout() {
	return (
		<ScrollArea className="h-full w-full">
			<div className="flex flex-col gap-4 p-6 pt-14">
				<header className="flex flex-col">
					<span className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
						Staff admin
					</span>
					<h1 className="text-2xl font-semibold tracking-tight">Firms</h1>
				</header>
				<Outlet />
			</div>
		</ScrollArea>
	);
}
